import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import "../../../../css/salesorder.css";
import {
    GetItemMasterGridData, GetOrderDetailGridData
} from "../../../../services/SalesOrderService";
import OrderDetailByLotResult from "./OrderDetailByLotResult";
import LocationSearchResult from "./ImLocationSearchResult";
import LocationSummaryResult from "./LocationSummaryResult";
import OpenRequisitionsTabResult from "../itemMaster/OpenRequisitionsTabResult";
import OpenPosTabResult from "../itemMaster/OpenPosTabResult";
import OpenPosReceiptTabResult from "../itemMaster/OpenPosReceiptTabResult";
import AllTransactionTabResult from "../itemMaster/AllTransactionTabResult";
import ItemMasterResult from "../salesOrdersTab/ItemMasterResult";
import CustomerResult from "../salesOrdersTab/CustomerResult";
const GetLocationSummayByLotIdUrl = "om/SaleOrder/GetLocationSummayByLotId";
const GetOpenRequisitionsByLotIdUrl = "om/SaleOrder/GetOpenRequisitionsByLotId";
const GetAllTransactionsByLotId = "om/SaleOrder/GetAllTransactionsByLotId";
const getGetItemOrdersBylotUrl = "om/SaleOrder/GetItemOrdersBylot";
const GetPosByLotUrl = "om/SaleOrder/GetPosByLot";
const GetPosReceiptByLotIdtUrl = "om/SaleOrder/GetPosReceiptByLotId";
const ItemLotTabs = forwardRef((props, ref) => {
    const itemOrdersTab = 1;
    const openRequisitionTab = 2;
    const openPOsTab = 3;
    const openPOsReceiptTab = 4;
    const allTransactionsTab = 5;
    const itemMasterTab = 6;
    const customerTab = 7;
    const locationTab = 8;
    const locationSummaryTab = 9;
    const getCustomerListUrl = "om/SaleOrder/GetCustomerList";
    const GetAllLocationsByLotUrl = "om/SaleOrder/GetAllLocationsByLot";
    const GetItemMasterMainUrl = "om/SaleOrder/GetItemMasterMain";
    const [orderDetailDataSource, setOrderDetailDataSource] = useState(null);
    const [openRequisitionsDataSource, setoOenRequisitionsDataSource] = useState(null);
    const [openPOsDataSource, setOpenPOsDataSource] = useState(null);
    const [openPOsReceiptDataSource, setOpenPOsReceiptDataSource] = useState(null);
    const [customerDataSource, setCustomerDataSource] = useState(null);
    const [locationDataSource, setLocationDataSource] = useState(null);
    const [locationSummaryDataSource, setlocationSummaryDataSource] = useState(null);
    const [itemMasterDataSource, setItemMasterDataSource] = useState(null);
    const [allTransactonDataSource, setAllTransactonDataSource] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);
    const [activeTab, setActiveTab] = useState(itemOrdersTab);

    useImperativeHandle(ref, () => ({
        updateData(data) {
            setSelectedRow(data);
        }
    }));

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };
    const LoadTabsData = () => {
        if (selectedRow) {
            if (activeTab === customerTab) {
                var resultData = GetItemMasterGridData(props.accessToken, getCustomerListUrl);
                setCustomerDataSource(resultData);
            }
            else if (activeTab === itemMasterTab) {
                var resultData = GetItemMasterGridData(props.accessToken, GetItemMasterMainUrl);
                setItemMasterDataSource(resultData);
            } else if (activeTab === locationTab) {
                var resultData = GetItemMasterGridData(props.accessToken, GetAllLocationsByLotUrl);
                setLocationDataSource(resultData);
            }
            else if (selectedRow.lotRowId && activeTab === itemOrdersTab) {
                var resultData = GetOrderDetailGridData(props.accessToken, getGetItemOrdersBylotUrl, selectedRow.lotRowId);
                setOrderDetailDataSource(resultData);
            } else if (selectedRow.lotRowId && activeTab === openRequisitionTab) {
                var resultData = GetOrderDetailGridData(props.accessToken, GetOpenRequisitionsByLotIdUrl, selectedRow.lotRowId);
                setoOenRequisitionsDataSource(resultData);
            } else if (selectedRow.lotRowId && activeTab === openPOsTab) {
                var resultData = GetOrderDetailGridData(props.accessToken, GetPosByLotUrl, selectedRow.lotRowId);
                setOpenPOsDataSource(resultData);
            } else if (selectedRow.lotRowId && activeTab === openPOsReceiptTab) {
                var resultData = GetOrderDetailGridData(props.accessToken, GetPosReceiptByLotIdtUrl, selectedRow.lotRowId);
                setOpenPOsReceiptDataSource(resultData);
            } else if (selectedRow.lotRowId && activeTab === allTransactionsTab) {
                var resultData = GetOrderDetailGridData(props.accessToken, GetAllTransactionsByLotId, selectedRow.lotRowId);
                setAllTransactonDataSource(resultData);
            } else if (selectedRow.lotRowId && activeTab === locationSummaryTab) {
                var resultData = GetOrderDetailGridData(props.accessToken, GetLocationSummayByLotIdUrl, selectedRow.lotRowId);
                setlocationSummaryDataSource(resultData);
            }
        }
    };
    useEffect(() => {
        LoadTabsData();
    }, [selectedRow, activeTab]);
    return (
        <div>
            <div className="tab-bar">
                <div
                    className={`tab ${activeTab === itemOrdersTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(itemOrdersTab)}
                >
                    Item Orders
                </div>
                <div
                    className={`tab ${activeTab === openRequisitionTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(openRequisitionTab)}
                >
                    Open Requisitions
                </div>
                <div
                    className={`tab ${activeTab === openPOsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(openPOsTab)}
                >
                    Open POs
                </div>
                <div
                    className={`tab ${activeTab === openPOsReceiptTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(openPOsReceiptTab)}
                >
                    Open PO Receipts
                </div>
                <div
                    className={`tab ${activeTab === allTransactionsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(allTransactionsTab)}
                >
                    All Transactions
                </div>
                <div
                    className={`tab ${activeTab === itemMasterTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(itemMasterTab)}
                >
                    Item Master
                </div>
                <div
                    className={`tab ${activeTab === customerTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerTab)}
                >
                    Customers
                </div>
                <div
                    className={`tab ${activeTab === locationTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(locationTab)}
                >
                    Location Master
                </div>
                <div
                    className={`tab ${activeTab === locationSummaryTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(locationSummaryTab)}
                >
                    Lot/Locations
                </div>
            </div>
            {activeTab === itemOrdersTab && (
                <OrderDetailByLotResult data={orderDetailDataSource} />
            )}
            {activeTab === openRequisitionTab && (
                <OpenRequisitionsTabResult data={openRequisitionsDataSource} />
            )}
            {activeTab === openPOsTab && (
                <OpenPosTabResult data={openPOsDataSource} />
            )}
            {activeTab === openPOsReceiptTab && (
                <OpenPosReceiptTabResult data={openPOsReceiptDataSource} />
            )}
            {activeTab === allTransactionsTab && (
                <AllTransactionTabResult data={allTransactonDataSource} />
            )}
            {activeTab === itemMasterTab && (
                <ItemMasterResult data={itemMasterDataSource} />
            )}
            {activeTab === customerTab && (
                <CustomerResult data={customerDataSource} />
            )}
            {activeTab === locationTab && (
                <LocationSearchResult data={locationDataSource} />
            )}
            {activeTab === locationSummaryTab && (
                <LocationSummaryResult data={locationSummaryDataSource} />
            )}
        </div>
    );
});

export default ItemLotTabs;